import { AxiosAdapter } from '../../../../../../../_config/adapters/axios/axios.adapter';
import { Http } from '../../../../../../../_config/adapters/axios/axios.protocols';
import { Enviroment } from '../../../../../../../_config/constants/enviroment-v2.constant';

export class Service {
	async getProducts() {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_BACKEND}/magistral-components`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}



	async addComponent({name, token}) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.FUNCTION_BACKEND}/magistral-components`,
			data: {name},
      headers: {
				Authorization: `Bearer ${token}`,
			},
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

}
